import { useEffect, useState } from 'react';
import { TextField } from 'src/components';
import Autocomplete from 'src/components/Autocomplete';
import VwOrganizasyonYetki from 'src/models/Base/Yetki/VwOrganizasyonYetkiDTO';
import { useAppSelector } from 'src/store';
import { helper } from 'src/utils/helper';
import { AutoCompleteTargetNumber } from '../Types/autocomplete.target';
import { SxProps, Theme } from '@mui/material';
import { useGetOrganizasyonByKullaniciQuery } from "src/services/OrganizasyonYetki/OrganizasyonApi";

interface IOrgYetkiAutoCompleteProps {
  value?: number;
  name?: string;
  label?: string;
  onChange?: (e: AutoCompleteTargetNumber, v?: VwOrganizasyonYetki) => void;
  helperText?: string;
  error?: boolean;
  id?: string;
  required?: boolean;
  sx?: SxProps<Theme>;
  disableClearable?: boolean;
}
const OrgYetkiAutocomplete = (props: IOrgYetkiAutoCompleteProps): JSX.Element => {
  const { userInfo } = useAppSelector(s => s.userLogin)
  const { data, isError, error } = useGetOrganizasyonByKullaniciQuery(userInfo.id)
  const [value, setValue] = useState<VwOrganizasyonYetki>(null);
  useEffect(() => {
    if (props?.value > 0) {
      setValue(data?.find(f => f?.fkOrganizasyon === props?.value));
    }
    else setValue(null)
  }, [data, props.value]);

  return (
    <Autocomplete
      fullWidth
      freeSolo={false}
      multiple={false}
      sx={props?.sx}
      id={props?.id}
      disableClearable={props?.disableClearable}
      value={value?.fkOrganizasyon > 0 ? value : null}
      options={data ? data : []}
      filterOptions={(option, state) => {
        return option?.filter(f => helper.UpperCaseAsc(f?.organizasyon).indexOf(helper.UpperCaseAsc(state?.inputValue)) > -1)
      }}
      getOptionLabel={(option) => {
        if (!option?.organizasyon)
          return "";
        return option?.organizasyon
      }
      }
      renderOption={(props, option) => {
        if (!option?.fkOrganizasyon)
          return "";
        return (
          <li {...props} key={option?.fkOrganizasyon}>
            {option?.organizasyon}
          </li>
        );
      }}
      isOptionEqualToValue={(o, v) => o?.fkOrganizasyon === v?.fkOrganizasyon}
      onChange={(e, newValue, r, d) => {
        if (props.onChange) {
          props.onChange({ target: { value: newValue?.fkOrganizasyon > 0 ? newValue.fkOrganizasyon : null, name: props?.name } }, newValue);
        }
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={props?.label}
          error={props?.error}
          helperText={props?.helperText || (isError && error?.message)}
          required={props?.required}
        />
      )}

    />
  );
};
export default OrgYetkiAutocomplete;